import React, { useState, useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Container, TextField, Typography, Grid } from '@material-ui/core';
import { patientActions } from '../../core/actions';
import { useDispatch } from 'react-redux';
import { RADIOLOGYREPORT } from '../../shared/constants';
import { useOrganization } from '../../configurations/OrganizationContext';
import PrintIcon from '@material-ui/icons/Print';
import RadiologyPrint from '../../mnh/RadiologyPrint';
import Components from '..';
// ADD THESE NEW IMPORTS
import {
  IconButton,
  Box
} from '@material-ui/core';
import FormatBoldIcon from '@material-ui/icons/FormatBold';
import FormatItalicIcon from '@material-ui/icons/FormatItalic';
import FormatUnderlinedIcon from '@material-ui/icons/FormatUnderlined';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
const useStyles = makeStyles((theme) => ({
  root: {
    height: '90vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3),
    position: 'relative',
    overflow: 'auto',
  },
  header: {
    marginBottom: theme.spacing(3),
    '& .MuiInputBase-root': {
      fontSize: '1rem',
      fontWeight: 'bold',
      lineHeight: 1.235,
      textAlign: 'center',
    },
    '& .MuiInputBase-input': {
      textAlign: 'center',
      fontWeight: 'bold',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none !important',
    },
    '& .Mui-focused': {
      '& .MuiInput-underline:after': {
        transform: 'scaleX(0)',
      },
    },
  },
  measurementHeader: {
    backgroundColor: '#f5f5f5',
    padding: theme.spacing(1),
    marginBottom: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
  },
  measurementLabel: {
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '0.875rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  editorContainer: {
    flex: 1,
    marginBottom: theme.spacing(3),
    '& .ql-toolbar': {
      display: 'none',  // ← HIDE TOOLBAR
    },

    // Preserve multiple spaces and line breaks exactly as typed
    '& .ql-editor': {
      whiteSpace: 'pre-wrap',
    },

    '& .ql-container': {
      border: 'none',
      fontFamily: theme.typography.fontFamily,
      fontSize: '1rem',
      lineHeight: '1.5',
    },
    '& .ql-container.ql-snow': {
      border: 'none',
    },
    '& .ql-editor p': {
      marginBottom: theme.spacing(2),
    },
  },
  doctorInfoContainer: {
    marginBottom: theme.spacing(3),
    '& .ql-toolbar': {
      display: 'none',  // ← HIDE TOOLBAR
    },
    '& .ql-editor': {
      whiteSpace: 'pre-wrap',
    },
    '& .ql-container': {
      border: 'none',
      fontFamily: theme.typography.fontFamily,
      fontSize: '1rem',
      lineHeight: '1.5',
      textAlign: 'center',
    },
    '& .ql-container.ql-snow': {
      border: 'none',
    },
    '& .ql-editor': {
      // textAlign: 'center',
      padding: theme.spacing(1),
    },
    '& .ql-editor p': {
      marginBottom: theme.spacing(1),
    },
  },
  doctorInfoLabel: {
    marginBottom: theme.spacing(1),
    fontWeight: 'bold',
    color: theme.palette.text.secondary,
  },
  buttonContainer: {
    textAlign: 'center',
    marginTop: theme.spacing(2),
  },
  formatToolbar: {
    marginBottom: theme.spacing(2),
    border: '1px solid #ddd',
    borderRadius: '4px',
    padding: theme.spacing(1),
    display: 'flex',
    gap: theme.spacing(1),
    backgroundColor: '#fff',
    '& .active': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  },
}));

const DopplerStudy = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [isVisible] = useState(true);
  const [currentFormats, setCurrentFormats] = useState({});

  const org = useOrganization();
  const [printData, setPrintData] = useState(null);
  const [title, setTitle] = useState('DOPPLER COLOUR DOPPLER STUDY OF CAROTID AND VERTEBRAL ARTERIAL SYSTEM');
  const [reportContent, setReportContent] = useState(
    `<p><strong><u>RIGHT SIDE:</u></strong> </p>
    <p><strong>Common C A</strong> </p>
    <p><strong>Carotid Bulb</strong> </p>
    <p><strong>Internal C A</strong> </p>
<p><strong>Vertebral C A</strong> </p>
<p><strong><u>LEFT SIDE:</u></strong> </p>
<p><strong>Common C A</strong> </p>
<p><strong>Carotid Bulb</strong> </p>
<p><strong>Internal C A</strong> </p>
<p><strong>Vertebral C A</strong> </p>
<p></p>
<p><strong>IMPRESSION:-</strong> </p>`
  );
  const [doctorInfo, setDoctorInfo] = useState(
    `<p><strong>${org?.isRadiology?.Doctor}</strong></p>
<p><strong>${org?.isRadiology?.Qualification}</strong></p>
<p><strong>${org?.isRadiology?.RegNo}</strong></p>`
  );
  const quillRefs = useRef({});
  const [activeQuill, setActiveQuill] = useState(null)
  const modules = {
    toolbar: false,  // ← CHANGE THIS
    clipboard: {
      matchVisual: false
    }
  };

  const formats = ['bold', 'italic', 'underline', 'list', 'bullet', 'header'];



  const convertToHTML = () => {
    return `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>${title}</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      line-height: 1.6;
      margin: 20px;
      white-space: pre-wrap;
    }
    .doppler-report {
      max-width: 800px;
      margin: 0 auto;
    }
    h1 {
      text-align: center;
      margin-bottom: 30px;
      font-size: 2.125rem;
      font-weight: bold;
    }
    .measurement-header {
      display: flex;
      justify-content: space-between;
      background-color: #f5f5f5;
      padding: 8px;
      margin-bottom: 15px;
      border-radius: 4px;
    }
    .measurement-label {
      font-weight: bold;
      text-align: center;
      font-size: 0.875rem;
      flex: 1;
    }
    .report-content {
      font-size: 1rem;
      line-height: 1.5;
      white-space: pre-wrap;
    }
    .report-content p {
      margin-bottom: 16px;
      white-space: pre-wrap;
    }
    .doctor-info {
      text-align: center;
      margin-top: 30px;
      margin-bottom: 20px;
      font-size: 1rem;
      line-height: 1.5;
    }
    .doctor-info p {
      margin-bottom: 8px;
    }
  </style>
</head>
<body>
  <div class="doppler-report">
    <h1>${title}</h1>
     <div class="measurement-header">
      <div class="measurement-label">Vessels</div>
      <div class="measurement-label">Walls</div>
      <div class="measurement-label"><div>Lumen</div><div>D(mms)</div></div>
      <div class="measurement-label"><div>SYS/DIAS</div><div>Cms/Sec</div></div>
      <div class="measurement-label">Resistive Index</div>
      <div class="measurement-label">Spectrum</div>
      <div class="measurement-label"><div>Stenosis</div><div>%</div></div>
    </div>
     <div class="report-content">
     ${reportContent.replace(/  /g, '&nbsp;&nbsp;')}
    </div>
    <div class="doctor-info">
      ${doctorInfo.replace(/  /g, '&nbsp;&nbsp;')}
    </div>
  </div>
</body>
</html>`;
  };



  const parseHTMLContent = (htmlString) => {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');

      const titleElement = doc.querySelector('h1');
      const extractedTitle = titleElement ? titleElement.textContent.trim() : 'DOPPLER STUDY';

      const contentElement = doc.querySelector('.report-content');
      const extractedContent = contentElement ? contentElement.innerHTML : '';

      const doctorElement = doc.querySelector('.doctor-info');
      const extractedDoctorInfo = doctorElement ? doctorElement.innerHTML :
        `<p><strong>${org?.isRadiology?.Doctor}</strong></p>
<p><strong>${org?.isRadiology?.Qualification}</strong></p>
<p><strong>${org?.isRadiology?.RegNo}</strong></p>`;

      return {
        title: extractedTitle,
        reportContent: extractedContent,
        doctorInfo: extractedDoctorInfo
      };
    } catch (error) {
      console.error('Error parsing HTML content:', error);
      return null;
    }
  };

  useEffect(() => {
    if (props.selectedProcedure) {
      const selectedProcedure = props.selectedProcedure;

      if (selectedProcedure.longdesc && selectedProcedure.longdesc !== "") {
        const longdesc = selectedProcedure.longdesc;

        if (longdesc.trim().startsWith('<') && longdesc.includes('</')) {
          const parsedData = parseHTMLContent(longdesc);
          if (parsedData) {
            setTitle(parsedData.title);
            setReportContent(parsedData.reportContent);
            setDoctorInfo(parsedData.doctorInfo);
          }
        } else {
          try {
            let parsedData = JSON.parse(longdesc);

            if (parsedData.title) {
              setTitle(parsedData.title);
            }

            if (parsedData.reportContent) {
              setReportContent(parsedData.reportContent);
            }

            if (parsedData.doctorInfo) {
              setDoctorInfo(parsedData.doctorInfo);
            }
          } catch (error) {
            console.error("Error parsing longdesc:", error);
          }
        }
      }
    }
  }, [props.selectedProcedure]);
  useEffect(() => {
    if (!activeQuill) return;
    const quill = activeQuill.getEditor();

    const updateFormats = () => {
      if (!quill) return;
      const range = quill.getSelection();
      if (range) {
        setCurrentFormats(quill.getFormat(range));
      }
    };

    quill.on('selection-change', updateFormats);
    quill.on('text-change', updateFormats);

    updateFormats(); // Initial call

    // Cleanup listeners on editor or activeQuill change
    return () => {
      quill.off('selection-change', updateFormats);
      quill.off('text-change', updateFormats);
    };
  }, [activeQuill]);


  // Quill ref management
  const setQuillRef = (key, ref) => {
    quillRefs.current[key] = ref;
  };

  const handleFocus = (key) => {
    setActiveQuill(quillRefs.current[key]);
  };


  // Toolbar handlers - apply to active editor
  const handleFormat = (format) => {
    if (!activeQuill) return;

    const quill = activeQuill.getEditor();
    const range = quill.getSelection();

    if (range) {
      if (format === 'bold' || format === 'italic' || format === 'underline') {
        const current = quill.getFormat(range);
        quill.format(format, !current[format]);
      } else if (format === 'list-ordered') {
        quill.format('list', 'ordered');
      } else if (format === 'list-bullet') {
        quill.format('list', 'bullet');
      }
    }
  };

  const editProcedure = (procedure) => {
    dispatch(
      patientActions.editProcedure(procedure, rescb => {
        if (rescb && rescb.successMessages) {
          props.closeModal({
            success: "DOPPLER  STUDY report updated  successfully",
          });
        } else {
          console.error("Error editing procedure:", rescb);
        }
      })
    );
  };

  const saveProcedure = (procedure) => {
    let new_procedure = {
      patientId: procedure.patientId,
      visitId: procedure.visitId,
      templateId: procedure.templateId,
      groupname: "ULTRASOUND",
      subgroup: RADIOLOGYREPORT,
      templateId: "DOPPLER  STUDY",
      longdesc: procedure.longdesc,
      notes: "Doppler Study Report",
      billNumber: props.selectedProcedure.billNumber,
      markForDel: procedure.markForDel,
      billable: false,
      packageService: props.selectedProcedure?.packageService ? props.selectedProcedure.packageService : null
    };
    if (new_procedure.packageService && new_procedure.billable) {
      new_procedure.packageService.billable = false;
    }

    dispatch(
      patientActions.insertToProcedure(new_procedure, rescb => {
        if (rescb && rescb.successMessages) {
          console.log("Procedure added successfully:", rescb);
          // props.closeModal({
          //   success: new_procedure.templateId + " report added  successfully",
          // });
        } else {
          console.error("Error adding procedure:", rescb);
        }
      })
    );
  };

  const handleSave = () => {
    const htmlData = convertToHTML();

    let updatedProcedure = props.selectedProcedure;
    if (props.selectedProcedure && props.selectedProcedure.longdesc) {
      updatedProcedure.groupname = "ULTRASOUND";
      updatedProcedure.subgroup = RADIOLOGYREPORT;
      updatedProcedure.longdesc = htmlData;
      editProcedure(updatedProcedure);
      props.closeModal({
        success: updatedProcedure.templateId + " report updated  successfully",
      });
    } else {
      if (updatedProcedure) {
        updatedProcedure.longdesc = htmlData;
        updatedProcedure.groupname = "ULTRASOUND";
        editProcedure(updatedProcedure);
        saveProcedure(updatedProcedure);
      } else {
        let new_procedure = {
          patientId: props.patientInfo.id,
          visitId: props.patientInfo.visit.id,
          groupname: "ULTRASOUND",
          subgroup: RADIOLOGYREPORT,
          templateId: "DOPPLER  STUDY",
          longdesc: htmlData,
          notes: "Doppler Study Report",
          billNumber: props.selectedProcedure.billNumber,
          markForDel: false,
          billable: false,
        };
        saveProcedure(new_procedure);
      }
    };
  }

  // Replace your handlePrint function in DopplerStudy.js with this:

  // const handlePrint = () => {
  //   try {
  //     const patient = props.patientInfo || props.patientData?.[0] || {};
  //     const person = patient.person || {};

  //     const procedureData = {
  //       patientId: patient.patientId || patient.id,
  //       visitId: patient.visitId,
  //       templateId: "DOPPLER  STUDY",
  //       subgroup: RADIOLOGYREPORT,
  //       reportContent: reportContent,  // Pass raw HTML content
  //       doctorInfo: doctorInfo,        // Pass raw HTML content
  //       title: title,                  // Pass the title
  //       longdesc: convertToHTML(),
  //       notes: "Doppler Study Report",
  //       packageService: {
  //         name: "DOPPLER  STUDY",
  //         description: "Doppler Study",
  //       },
  //       procedureslist: [{
  //         ...props.selectedProcedure,
  //         longdesc: convertToHTML()
  //       }]
  //     };

  //     setPrintData({
  //       selectedPatient: {
  //         ...patient,
  //         id: patient.patientId || patient.id,
  //         fullName: patient.fullName || `${person.firstName || ''} ${person.lastName || ''}`.trim(),
  //         age: patient.age || person.age
  //       },
  //       templateId: "DOPPLER  STUDY",
  //       patientData: procedureData
  //     });
  //   } catch (error) {
  //     console.error("Print preparation error:", error);
  //   }
  // };

  return (
    <Container maxWidth="lg" className={classes.root}>
      <TextField
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        fullWidth
        className={classes.header}
        inputProps={{
          'aria-label': 'report title',
          style: {
            fontWeight: 'bold',
            textAlign: 'center',
            cursor: 'text'
          }
        }}
        InputProps={{
          disableUnderline: true,
        }}
      />
      {/* Unified Toolbar */}
      <Box className={classes.formatToolbar}>
        <IconButton onClick={() => handleFormat('bold')} aria-label="bold" className={currentFormats.bold ? 'active' : ''}>
          <FormatBoldIcon />
        </IconButton>
        <IconButton onClick={() => handleFormat('italic')} aria-label="italic" className={currentFormats.italic ? 'active' : ''}>
          <FormatItalicIcon />
        </IconButton>
        <IconButton onClick={() => handleFormat('underline')} aria-label="underline" className={currentFormats.underline ? 'active' : ''}>
          <FormatUnderlinedIcon />
        </IconButton>
        <IconButton onClick={() => handleFormat('list-ordered')} aria-label="ordered list" className={currentFormats.list === 'ordered' ? 'active' : ''}>
          <FormatListNumberedIcon />
        </IconButton>
        <IconButton onClick={() => handleFormat('list-bullet')} aria-label="bullet list" className={currentFormats.list === 'bullet' ? 'active' : ''}>
          <FormatListBulletedIcon />
        </IconButton>
      </Box>
      <Grid container spacing={1} className={classes.measurementHeader}>
        <Grid item xs>
          <Typography className={classes.measurementLabel}>VESSELS</Typography>
        </Grid>
        <Grid item xs>
          <Typography className={classes.measurementLabel}>WALLS</Typography>
        </Grid>
        <Grid item xs>
          <div className={classes.measurementLabel}>
            <div style={{ display: 'block' }}>LUMEN</div>
            <div style={{ display: 'block' }}>D(mms)</div>
          </div>
        </Grid>
        <Grid item xs>
          <div className={classes.measurementLabel}>
            <div style={{ display: 'block' }}>SYS/DIAS</div>
            <div style={{ display: 'block' }}>Cms/Sec</div>
          </div>
        </Grid>
        <Grid item xs>
          <div className={classes.measurementLabel}>
            <div style={{ display: 'block' }}>RESISTIVE</div>
            <div style={{ display: 'block' }}>Index</div>
          </div>
        </Grid>
        <Grid item xs>
          <Typography className={classes.measurementLabel}>SPECTRUM</Typography>
        </Grid>
        <Grid item xs>
          <div className={classes.measurementLabel}>
            <div style={{ display: 'block' }}>STENOSIS</div>
            <div style={{ display: 'block' }}>%</div>
          </div>  </Grid>
      </Grid>

      <div className={classes.editorContainer}>
        <ReactQuill
          ref={ref => setQuillRef('reportContent', ref)}
          value={reportContent}
          onChange={setReportContent}
          modules={modules}
          formats={formats}
          theme="snow"
          onFocus={() => handleFocus('reportContent')}
        />
      </div>

      <div className={classes.doctorInfoContainer}>
        <ReactQuill
          ref={ref => setQuillRef('doctorInfo', ref)}
          value={doctorInfo}
          onChange={setDoctorInfo}
          modules={modules}
          formats={formats}
          theme="snow"
          placeholder="Enter doctor information..."
          onFocus={() => handleFocus('doctorInfo')}
        />
      </div>

      <div className={classes.buttonContainer}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          size="large"
          style={{ marginRight: '16px' }}
        >
          Save
        </Button>
      </div>
      {printData && (
        <div style={{ display: 'none' }}>
          <Components.RadiologyPrint


            doctorInfo={doctorInfo}
            patientData={printData.patientData}
            templateId={printData.templateId}
            selectedPatient={printData.selectedPatient}

          />
        </div>
      )}
    </Container>
  );
};

export default DopplerStudy;